import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Fire = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="fire icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M12.1971 12.7201C11.6854 15.7897 9.12755 16.8128 9.12755 19.3708C9.12755 20.3553 9.33805 21.1294 9.62404 21.8279C9.84017 22.3558 9.47562 22.9445 8.91542 22.8368C5.5498 22.1899 3.5 18.8882 3.5 14.7665C3.5 12.2757 4.51058 9.44804 5.98505 7.65027C6.38608 7.16131 7.07995 7.48338 7.09184 8.11565C7.12001 9.61468 7.22222 11.3265 7.59272 11.697C8.06705 7.90193 11.1807 7.18601 11.2233 1.79953C11.228 1.20307 11.855 0.788238 12.3542 1.11471C16.8977 4.0861 14.3531 7.75049 15.7782 9.65059C16.0368 8.35783 16.7173 7.54147 17.3554 7.07252C17.7863 6.75585 18.2722 7.14898 18.258 7.68357C18.1616 11.2999 20.5 12.2594 20.5 16C20.5 19.5363 18 21.8665 14.1419 22.9611C13.4722 23.1793 12.9985 22.4343 13.4154 21.8665C14.4187 20.5002 15.1265 19.1822 14.755 17.3244C14.4832 17.8679 13.8957 18.3663 13.2321 18.6399C12.7479 18.8395 12.3636 18.3442 12.4795 17.8334C12.848 16.208 13.0248 13.9618 12.1971 12.7201Z"
    />
  </svg>
)
